// loginSrc.js
import axios from 'axios'
import url from '../../api/env'
import api from '../../api/api'
import src from '../../context/cacheApp'
import Utils from '../../utils/Utils'

const authLogin = (usernameOrEmail, password) => {
  // Dejamos que axios maneje el error y lo lance al catch de quien lo llame
  return axios.post(`${url.stage.login}`, {
    username: usernameOrEmail,
    password: password,
  })
}

const forceLogout = (usernameOrEmail, password) => {
  console.log("Bandera de cierre forzozo");
  
  return axios.post(`${url.stage.apiforceLogout}`, {
    username: usernameOrEmail,
    password: password,
  })
}

const closeSession = async () => {
  try {
    const response = await axios.post(
      `${url.stage.logout}`,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + src.sessionApp(null, 'token'),
          'Content-Type': 'application/json',
        },
      }
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

const resetPassword = async data =>
  api
    .put(url.stage.reset, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))

const currentUser = async () =>
  api
    .get(url.stage.currentUser, {})
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearForAuthError() : console.log(err)))



export default {
  authLogin,
  closeSession,
  currentUser,
  resetPassword,
  forceLogout,
}
